<template>
    <footer class="footer" v-show="show">
        <div class="d-flex justify-content-center">
            <div class="container row m-0">
                <div class="col-md-3 bar-right">
                    <div class="d-flex justify-content-center">
                        <img src="/favicon.png" alt="貸し本棚" class="img-icon">
                    </div>
                    <div class="mt-3 text-center">
                        貸し本棚
                    </div>
                    <div class="small text-center">
                        Web小説家の隠れ家・小説投稿サイト
                    </div>
                    <div class="my-3">
                        <a href="https://x.com/KatohNoriyasu" target="_blank" class="btn btn-twitter btn-sm btn-block">
                            <i class="fab fa-twitter"></i>
                            運営者
                        </a>
                    </div>
                </div>
                <div class="col-md-6 row">
                    <div class="col-6 bar-right">
                        <div class="caption">小説を探す</div>
                        <ul class="footer-menus">
                            <li>
                                <v-link path="/novels/long">長編小説</v-link>
                            </li>
                            <li>
                                <v-link path="/novels/short">短編小説</v-link>
                            </li>
                            <li>
                                <v-link path="/novels/finishes">完結作品</v-link>
                            </li>
                            <li>
                                <v-link path="/novels/updates">更新された小説</v-link>
                            </li>
                            <li>
                                <v-link path="/novels/news">新着小説</v-link>
                            </li>
                            <li v-if="$store.state.user && $store.state.user.rating && $store.state.user.rating.rating_level >= 2">
                                <v-link path="/novels/r18">R18小説</v-link>
                            </li>
                            <li v-if="$store.state.user && $store.state.user.rating && $store.state.user.rating.rating_level >= 3">
                                <v-link path="/novels/xxx">XXX小説</v-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-6 bar-right">
                        <div class="caption">メインメニュー</div>
                        <ul class="footer-menus">
                            <li v-if="!isInner">
                                <v-link path="/">ポータル</v-link>
                            </li>
                            <li>
                                <v-link path="/about">貸し本棚とは</v-link>
                            </li>
                            <li v-if="!isLoggedIn"><a href="/register">ユーザー登録</a></li>
                            <li v-if="!isLoggedIn"><a href="/login">ログイン</a></li>
                            <li v-if="isLoggedIn">
                                <v-link path="/mypage">マイページ</v-link>
                            </li>
                            <li>
                                <v-link path="/terms-of-use">利用規約</v-link>
                            </li>
                            <li>
                                <v-link path="/notices">お知らせ</v-link>
                            </li>
                            <li>
                                <v-link path="/contact">お問い合わせ</v-link>
                            </li>
                            <li>
                                <v-link path="/help">ヘルプ</v-link>
                            </li>
                            <li>
                                <v-link path="/privacy">プライバシーポリシー</v-link>
                            </li>
                            <li>
                                <v-link path="/guideline">ガイドライン</v-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="caption">ヘルプ</div>
                    <ul class="footer-menus">
                        <li>
                            <v-link path="/help/novel/book">小説を書く</v-link>
                        </li>
                        <li>
                            <v-link path="/help/account/register">ユーザーアカウント</v-link>
                        </li>
                        <li>
                            <v-link path="/help/read/search">小説を読む</v-link>
                        </li>
                        <li>
                            <v-link path="/help/article/write">記事を書く</v-link>
                        </li>
                        <li>
                            <v-link path="/help/other/share">その他</v-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="small text-center my-4">
            Copyright &copy; {{year}} Kashi-Hondana.
        </div>
    </footer>
</template>

<style scoped lang="scss">
.footer {
    font-size: .9rem;
    padding-top: 1rem;
    margin-top: 7rem;
    background-color: rgba(197, 197, 197, .2);
    .caption {
        font-weight: bold;
        font-size: 1rem;
        margin-bottom: 0.75rem;
    }
    .footer-menus {
        list-style: none;
        margin: 0px;
        padding: 0em;
        padding-left: 0em;
        a {
            color: #222;
        }
    }
    .bar-right {
        border-right: 1px solid #ccc;
    }
    .img-icon {
        max-width: 96px;
        height: auto;
        padding: .25rem;
        border: 1px solid #aaa;
        border-radius: .75rem;
    }
}
@media screen and (max-width: 770px) {
    .footer {
        .bar-right {
            border-right: 0;
        }
    }
}
</style>

<script>
export default {
    data() {
        return {
            show: false,
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.state.user?.id;
        },
        year() {
            return moment().format("YYYY");
        },
        isInner() {
            if (this.$store.state.subdomain) {
                return false;
            }
            return true;
        },
        outer() {
            return "//www" + this.$store.state.base_domain;
        }
    },
    mounted() {
        setTimeout(() => {this.show = true}, 1500);
    }
}
</script>